const MASS_UNITS=new Set(['g','kg','oz','lb']);

function issue(field,code,message){return Object.freeze({field,code,message});}
function active(values=[]){return (values||[]).filter(value=>!value?.deletedAt);}

export function validatePlannedJournal({items=[],stages=[],stageTargets=[]}={}){
  const errors=[];
  const liveItems=active(items);
  const liveStages=active(stages);
  if(!liveItems.length)errors.push(issue('items','ITEM_REQUIRED','Add at least one item before planning this session.'));
  if(!liveStages.length)errors.push(issue('stages','STAGE_REQUIRED','Add at least one stage before planning this session.'));

  for(const item of liveItems){
    if(item.mass!=null||item.massUnit!=null){
      const mass=Number(item.mass);
      const unit=String(item.massUnit||'').toLowerCase();
      if(!Number.isFinite(mass)||mass<=0||!MASS_UNITS.has(unit)){
        errors.push(issue(`item:${item.id}:mass`,'INVALID_MASS','Enter a positive mass and a supported unit.'));
      }
    }
  }

  const stageIds=new Set(liveStages.map(stage=>stage.id));
  for(const target of stageTargets||[]){
    if(!stageIds.has(target.stageId))continue;
    const min=target.minChamberCelsius==null?null:Number(target.minChamberCelsius);
    const max=target.maxChamberCelsius==null?null:Number(target.maxChamberCelsius);
    const chamber=target.targetChamberCelsius==null?null:Number(target.targetChamberCelsius);
    const duration=target.plannedDurationMinutes==null?null:Number(target.plannedDurationMinutes);
    if([min,max,chamber].some(value=>value!=null&&!Number.isFinite(value))||min!=null&&max!=null&&min>max||chamber!=null&&min!=null&&chamber<min||chamber!=null&&max!=null&&chamber>max){
      errors.push(issue(`stage:${target.stageId}:temperature`,'INVALID_TEMPERATURE','Check the stage temperature target and range.'));
    }
    if(duration!=null&&(!Number.isInteger(duration)||duration<=0)){
      errors.push(issue(`stage:${target.stageId}:timing`,'INVALID_TIMING','Enter a positive whole number of minutes for stage duration.'));
    }
  }
  return Object.freeze({valid:errors.length===0,errors:Object.freeze(errors),errorCount:errors.length});
}

export function journalEmptyState({sessions=[],items=[],stages=[]}={}){
  if(!(sessions||[]).length)return Object.freeze({kind:'sessions',title:'Plan your first smoking session',action:'create_session'});
  if(!(items||[]).length)return Object.freeze({kind:'items',title:'Add what you are smoking',action:'add_item'});
  if(!(stages||[]).length)return Object.freeze({kind:'stages',title:'Build the smoking process',action:'add_stage'});
  return null;
}

export function recoverableJournalError(error,{draft}={}){
  return Object.freeze({ok:false,retryable:true,message:'Your changes are still saved on this device. Try again when ready.',draft,errorCode:String(error?.code||error?.message||'JOURNAL_SAVE_FAILED').slice(0,80)});
}
